<template>
  <!-- Bundle Sidebar -->
  <div class="relative border border-gray-500 px-3 pb-3">
    <h4 class="bundle-title">{{ strings.package_title }}</h4>
    <p class="text-xs text-gray-650">
      {{ strings.package_text }}
    </p>

    <img
      v-if="Object.keys(box).length > 0"
      :src="box.image.full_src"
      :alt="box.attributes.attribute_color"
      class="w-full my-4"
    />

    <select class="w-full text-sm uppercase" @change="onSelect($event)">
      <option
        v-for="item in boxes"
        :key="item.variation_id"
        :value="item.variation_id"
        :selected="box.variation_id == item.variation_id"
      >
        {{ item.attributes.attribute_color }}
      </option>
    </select>
  </div>
</template>

<script>
const elm = document.querySelector(
  '.bundled_product:not(.bundled_item_optional) .bundled_item_cart_content'
);

export default {
  data () {
    return {
      boxes: [],
      box: {},
      price: 0,
      quantity: 1
    };
  },
  props: {
    strings: {
      type: Object,
      default: null
    }
  },
  computed: {},
  methods: {
    onPackage (event) {
      this.boxes = event.detail.data;

      this.$nextTick(() => {
        const selected = elm.querySelector('select');

        let value = selected.value;

        this.box = this.boxes.find((obj) => {
          return obj.attributes.attribute_color === value;
        });
      });
    },
    onSelect (event) {
      const select = elm.querySelector('select');

      this.box = this.boxes.find((obj) => {
        return obj.variation_id == event.target.value;
      });

      if (this.box) {
        const color = this.box.attributes.attribute_color;

        let result = (select.querySelector(
          '[value="' + color + '"]'
        ).selected = true);

        $('#' + select.id).trigger('change');
      }
    }
  },
  mounted () {
    elm.addEventListener('package', this.onPackage);
  }
};
</script>
